import { render, staticRenderFns } from "./SubmitalNavbar.vue?vue&type=template&id=0768bead&"
import script from "./SubmitalNavbar.vue?vue&type=script&lang=js&"
export * from "./SubmitalNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports